<div class="inputSpacer" data-privacy-hide="true" data-hj-suppress data-dd-privacy="mask">
    <div class="inputSpacer__displayContainer"
         aria-hidden="true"
         data-spacerInput-element="display">
    </div>
    <span class="inputSpacer__line"></span>
    <span class="inputSpacer__line"></span>
    <span class="inputSpacer__line"></span>
</div>
